export interface Product {
  id: number;
  slug: string;
  name: string;
  description: string;
  longDescription: string | null;
  price: string;
  originalPrice: string | null;
  image: string;
  category: string;
  badge: string | null;
  badgeColor: string | null;
  features: string[] | null;
  inStock: boolean;
  rating: string | null;
  reviews: string | null;
  downloadFile?: string | null;
  screenshots?: string[];
  createdAt: Date;
  updatedAt: Date;
}

export interface CartItem {
  product: Product;
  quantity: number;
}

// Parse price for display
export function getPriceNum(price: string | null): number {
  return price ? parseFloat(price) : 0;
}

export function getPriceStr(price: string | null): string {
  return getPriceNum(price).toFixed(2).replace('.', ',');
}

export function getRatingNum(rating: string | null): number {
  return rating ? parseFloat(rating) : 0;
}

export function getReviewsNum(reviews: string | null): number {
  return reviews ? parseInt(reviews) : 0;
}